var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "product" }, [
    _c(
      "div",
      { staticClass: "product-container-inner" },
      [
        _c("h3", [
          !_vm.customClub
            ? _c("span", { staticClass: "amount" }, [
                _vm._v(_vm._s(_vm.singleProduct.amount) + "x"),
              ])
            : _vm._e(),
          _vm._v("\n      " + _vm._s(_vm.singleProduct.title) + "\n    "),
        ]),
        _vm._v(" "),
        _vm.singleProduct.award_winner
          ? _c("div", { staticClass: "award-winner" }, [
              _vm._v("\n      Award Winner\n    "),
            ])
          : _vm._e(),
        _vm._v(" "),
        !_vm.showAbstract
          ? [
              _c(
                "transition",
                { attrs: { name: "slide-fade" } },
                [
                  _vm.singleProduct.images[0]
                    ? [
                        _c(
                          "div",
                          {
                            staticClass: "cursor-q",
                            on: {
                              click: function ($event) {
                                _vm.showAbstract = true
                              },
                            },
                          },
                          [
                            _c("AImage", {
                              attrs: {
                                img: _vm.singleProduct.images[0].image,
                                preset: "__original",
                                contain: "",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    : _vm._e(),
                ],
                2
              ),
            ]
          : [
              _c("transition", { attrs: { name: "slide-fade" } }, [
                _c("div", {
                  staticClass: "abstract cursor-q",
                  domProps: { innerHTML: _vm._s(_vm.singleProduct.abstract) },
                  on: {
                    click: function ($event) {
                      _vm.showAbstract = false
                    },
                  },
                }),
              ]),
            ],
        _vm._v(" "),
        _vm.customClub && _vm.singleProduct.productsettings.price
          ? _c("div", { staticClass: "money-amount" }, [
              _c("span", { staticClass: "currency" }, [
                _vm._v(
                  _vm._s(
                    this.$store.getters["ecommerce/getConfigItem"]("currency")
                  ) + "$"
                ),
              ]),
              _vm._v(
                " " +
                  _vm._s(
                    parseFloat(_vm.singleProduct.productsettings.price).toFixed(
                      2
                    )
                  ) +
                  "\n    "
              ),
            ])
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }